export function getBaseURL() {
  // eslint-disable-next-line no-undef
  return process.env.REACT_APP_BASE_URL || "default-value";
}
